"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _updateNotificationEmailsReducer = _interopRequireDefault(require("./staging/updateNotificationEmailsReducer"));

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _CreateNewBlog = _interopRequireDefault(require("../stagedObjects/CreateNewBlog"));

var _CustomDateFormat = _interopRequireDefault(require("../stagedObjects/CustomDateFormat"));

var _DeleteBlog = _interopRequireDefault(require("../stagedObjects/DeleteBlog"));

var _redux = require("redux");

var _default = (0, _redux.combineReducers)({
  newBlog: _CreateNewBlog.default.getReducer(),
  customDateFormat: _CustomDateFormat.default.getReducer(),
  deleteBlog: _DeleteBlog.default.getReducer(),
  updateBlogGeneral: _UpdateBlogSettings.default.getReducer(),
  updateNotificationEmails: _updateNotificationEmailsReducer.default
});

exports.default = _default;
module.exports = exports.default;